import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { KeycloakSessionService } from "../auth/keycloak-session.service";

@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {

  constructor(
    private readonly router: Router,
    private readonly keycloakSession: KeycloakSessionService
  ) {}


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && request.headers.has('Authorization')) {
          console.debug('[ErrorsInterceptor] 401 Unauthorized — clearing session and redirecting to login. URL:', error.url);
          this.keycloakSession.clearSession();
          void this.router.navigate(['login']);
        }
        return throwError(() => error);
      })
    );
  }
}

export const errorInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: ErrorsInterceptor, multi: true}
];
